import React, { Component } from "react";
import { IoMdClose } from "react-icons/io";
import styles from "./styles.module.scss";


class Sidepanel extends Component {
  state = {};
  render(){
    const { open, onHide } = this.props;
    return (
      <div className={open ? styles.showContainer : styles.hideContainer}>
      <div className={styles.background} />
      <div
        className={
          open ? styles.sidebarContainerOpen : styles.sidebarContainerClosed
        }
      >
        <div className={styles.closeIcon}>
          <IoMdClose fontSize={40} onClick={onHide} />
        </div>
        {this.props.children}
      </div>
    </div> 
    )
  }
}

export default Sidepanel;
